module.exports = __webpack_public_path__ + "static/media/undraw_movie_night_93wl.e13a12a2.svg";